/* Sahya: KI-Kennzeichnung immer innerhalb der tatsaechlich sichtbaren Bildflaeche platzieren.
   Bei eingepassten Bildern (object-fit: contain) bleibt um das Foto ein Rand; der Abstand wird hier gemessen
   und als --sahya-ai-dx / --sahya-ai-dy an die Kennzeichnung gegeben (CSS: right/bottom = 6px + Abstand). */
(function () {
  function place(label) {
    var frame = label.parentElement;
    var img = frame && frame.querySelector('img');
    if (!img) return;
    var fr = frame.getBoundingClientRect();
    var ir = img.getBoundingClientRect();
    if (!fr.width || !ir.width) return;
    var right = ir.right, bottom = ir.bottom;
    var cs = getComputedStyle(img);
    if (cs.objectFit === 'contain' && img.naturalWidth && img.naturalHeight) {
      var s = Math.min(ir.width / img.naturalWidth, ir.height / img.naturalHeight);
      var w = img.naturalWidth * s, h = img.naturalHeight * s;
      right = ir.left + (ir.width + w) / 2;
      bottom = ir.top + (ir.height + h) / 2;
    }
    var dx = Math.max(0, Math.round(fr.right - Math.min(right, fr.right)));
    var dy = Math.max(0, Math.round(fr.bottom - Math.min(bottom, fr.bottom)));
    label.style.setProperty('--sahya-ai-dx', dx + 'px');
    label.style.setProperty('--sahya-ai-dy', dy + 'px');
  }
  function placeAll() {
    document.querySelectorAll('.sahya-ai-label').forEach(place);
  }
  var t;
  function schedule() { clearTimeout(t); t = setTimeout(placeAll, 50); }
  document.addEventListener('DOMContentLoaded', placeAll);
  window.addEventListener('load', placeAll);
  window.addEventListener('resize', schedule);
  document.addEventListener('click', schedule, true);
  document.addEventListener('load', function (e) { if (e.target && e.target.tagName === 'IMG') schedule(); }, true);
  if (window.MutationObserver) {
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'hidden', 'aria-hidden', 'aria-current'] });
  }
})();
